<template>
  <hm-container>
    <div slot="header">
      <el-radio-group v-model="queryType" size="small" @change="handleClick">
        <el-radio-button label="user">用户标签分类</el-radio-button
        ><el-radio-button label="goods">商品标签分类</el-radio-button>
      </el-radio-group>
    </div>
    <div class>
      <div class="flex flex-between mb20">
        <el-button type="primary" size="small" @click="addCategory"
          >新增分类</el-button
        >
        <div>
          <el-input
            clearable
            v-model.trim="catName"
            placeholder="输入分类名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        :data="categoryList"
        style="width: 100%"
        stripe
        size="small"
        border
        lazy
        row-key="id"
        :load="load"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          label="分类名称"
          prop="catName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tagCount"
          label="标签总数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="添加子分类" placement="top">
                <div
                  v-if="scope.row.level < 2"
                  class="pointer mr10"
                  @click="addChild(scope.row)"
                >
                  <span class="hmicon icon-tianjiaxiaji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  v-if="scope.row.catType !== 'System'"
                  class="pointer"
                  @click="remove(scope.row)"
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="分类层级">
          <el-radio-group
            v-model="ruleForm.level"
            :disabled="mode === 'addChild'"
            @change="switchLevel"
          >
            <el-radio :label="1">一级分类</el-radio>
            <el-radio :label="2">子分类</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类名称" prop="catName">
          <el-input
            v-model="ruleForm.catName"
            maxlength="20"
            size="small"
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级分类" v-if="ruleForm.level === 2">
          <el-cascader
            v-if="mode !== 'addChild'"
            ref="cascader"
            v-model="ruleForm.catId"
            :disabled="ruleForm.level === 1"
            :props="props"
            :options="options"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
          <el-input
            v-if="mode === 'addChild'"
            :value="currentRow.catName"
            size="small"
            type="text"
            disabled
          />
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="save"
          :disabled="!ruleForm.catId.length && ruleForm.level === 2"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      queryType: "user",
      hmUploadVisible: false,
      ruleForm: {
        isFrontShow: "yes",
        catId: [],
        level: 1,
        categoryLogo: "",
        catName: "",
        seqNum: ""
      },
      rules: {
        catName: {
          required: true,
          trrger: "blur",
          message: "请输入分类名"
        },
        isFrontShow: {
          required: true,
          trrger: "blur",
          message: "请选择"
        }
      },
      show: false,
      props: {
        value: "id",
        label: "catName",
        checkStrictly: true
      },
      options: [],
      title: "",
      mode: "add",
      catName: "",
      sort: {},
      wxshopParentCategoryId: "",
      parentCategoryName: "",
      dialogVisible: false,
      currentRow: {},
      tableData1: [],
      currentPage: 1,
      pageSize: 10,
      categoryList: [],
      total: 0
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryAllTag() {
      const { result } = await this.$store.dispatch("queryAllTagCat", {
        queryType: this.queryType
      });
      result.forEach(v => {
        delete v.children;
      });
      this.options = result;
    },
    handleClick() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    switchLevel() {
      this.ruleForm.catId = [];
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryTagCategoryList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        catName: this.catName,
        queryType: this.queryType
      });
      let { records, total } = result;
      this.categoryList = records;
      this.total = total;
    },
    hmUploadSuccess(url) {
      this.ruleForm.categoryLogo = url;
      this.hmUploadVisible = false;
    },
    addCategory() {
      this.mode = "add";
      this.title = "新增分类";
      this.dialogVisible = true;
      this.queryAllTag();
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    addChild(row) {
      this.mode = "addChild";
      this.title = "新增子分类";
      this.currentRow = row;
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
        this.ruleForm.level = row.level + 1;
        this.ruleForm.catId = [this.currentRow.id];
      }, 0);
    },
    async edit(row) {
      this.mode = "edit";
      this.title = "编辑分类";
      this.currentRow = row;
      this.dialogVisible = true;
      this.queryAllTag();
      const { result } = await this.$store.dispatch("queryTagCatDetails", {
        id: this.currentRow.id
      });
      this.ruleForm.level = result.level;
      this.ruleForm.catName = result.catName;
      this.ruleForm.catId = [result.parentId];
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.catId = [];
    },
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("removeTagCategory", {
          id: row.id
        });
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryList();
      }
    },
    save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          let parentId = "";
          if (this.ruleForm.level === 1) {
            parentId = this.queryType === "user" ? 1 : 2;
          } else {
            parentId = this.ruleForm.catId[0];
          }
          let params = {
            catName: this.ruleForm.catName,
            parentId,
            level: this.ruleForm.level
          };
          let actionName = "";
          if (this.mode === "add" || this.mode === "addChild") {
            actionName = "addTagCategory";
          } else if (this.mode === "edit") {
            params = Object.assign(params, {
              id: this.currentRow.id
            });
            actionName = "editTagCategory";
          }
          await this.$store.dispatch(actionName, params);
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.queryList();
        } else {
          return false;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async load(tree, treeNode, resolve) {
      const { id } = tree;
      resolve([]);
      try {
        const { result } = await this.$store.dispatch("queryNextLevelTagCat", {
          id: id,
          pageNo: 1,
          pageSize: 999
        });
        result.forEach(v => {
          v.hasChildren = Boolean(v.hasChildren);
        });
        resolve(result);
      } catch (error) {
        resolve([]);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.upload-upload-btn {
  position: relative;
  border: 1px solid #ddd;
  text-align: center;
  box-sizing: border-box;
  padding: 10px;
  margin-right: 10px;
  width: 120px;
  height: 120px;
  cursor: pointer;

  .close-wrapper {
    position: absolute;
    top: -20px;
    right: -10px;
    z-index: 100;
    .hmicon {
      font-size: 20px;
    }
  }

  .add-wrapper {
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: #e50065;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    margin: 0 auto;
    span {
      font-size: 12px;
    }
    cursor: pointer;
    .hmicon {
      font-size: 14px;
    }
  }
}
.logo {
  width: 80px;
}
</style>
